module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phone":"Phone","multiple numbers possible":"multiple numbers possible"},"de":{"phone":"Telefon","multiple numbers possible":"mehrere Nummern möglich"}}')
  delete Component.options._Ctor
}
